<div class="row">
  <div class="col-md-12">
    <button mat-icon-button class="lbl" [mat-dialog-close]="true" color="accent" style="color: #a3a3a3"
      aria-label="Example icon button with a close icon">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="col-md-12">
    <h4 class="text-center">Query</h4>
  </div>
</div>

<mat-dialog-content class="mat-typography" [formGroup]="queryForm">
  <div class="row row-flex">
    <div class="col-md-12">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <mat-label class="label-flex">Query Response <span class="text-danger">*</span></mat-label>
          <textarea matInput placeholder="Enter response" formControlName="queryResponse"></textarea>
          <mat-error *ngIf="
                queryForm.controls.queryResponse.touched &&
                queryForm.controls.queryResponse.hasError('required')
              ">
            Query response is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <mat-label class="label-flex">Responded By <span class="text-danger">*</span></mat-label>
          <input matInput placeholder="Enter Responded By" formControlName="updatedBy" />
          <mat-error *ngIf="
                queryForm.controls.updatedBy.touched &&
                queryForm.controls.updatedBy.hasError('required')
              ">
            Query response is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-md-4">
      <div id="upload_button">
        <label class="save_btn, save_secondary" style="padding: 0.4rem">
          <a color="primary">Choose File</a>
          <input type="file" accept=".jpg, .jpeg, .pdf, .tiff" (change)="addQueryDocument($event)" />
        </label>

      </div>
    </div>
  </div>
  <p *ngIf="documentBucket[0]">{{ documentBucket[0]?.name }}
    <button mat-icon-button color="warn" (click)="removeQueryDocument()">
      <mat-icon>delete</mat-icon>
    </button>
  </p>
</mat-dialog-content>

<mat-dialog-actions class="lbl">
  <button mat-raised-button color="primary" [disabled]="!queryForm.valid" class="save_changes" (click)="submitQuery()"
    cdkFocusInitial>
    Submit
  </button>
</mat-dialog-actions>